import { LEARN_LAUNCH_CONFIG } from '@/constants/learnLaunchConfig';
import { AdvancedToolGateScreen } from '@/features/unified-learning/runtime/components/AdvancedToolGateScreen';
import { GapSessionResultScreen } from '@/features/unified-learning/runtime/screens/GapSessionResultScreen';

export default function LearnReverseResultRoute() {
  if (!LEARN_LAUNCH_CONFIG.advancedTools.reverse) {
    return <AdvancedToolGateScreen tool="reverse" />;
  }
  return <GapSessionResultScreen />;
}
